// extracted by mini-css-extract-plugin
module.exports = {"citat":"citat__styles-module--3VI9u","heading":"heading__styles-module--O4MNw","text":"text__styles-module--24pKk","persontitle":"persontitle__styles-module--322y9"};